/**
 * @generated SignedSource<<9790836153bfb14e34f258f1f901eeb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActionItemIntegrationsDisconnectUserMutation$variables = {};
export type ActionItemIntegrationsDisconnectUserMutation$data = {
  readonly disconnectUserFromIntegration: {
    readonly deletedUserIntegrationId: string;
    readonly viewer: {
      readonly integrations: {
        readonly " $fragmentSpreads": FragmentRefs<"ActionItemIntegrationsUserIntegration">;
      };
    } | null;
  } | null;
};
export type ActionItemIntegrationsDisconnectUserMutation = {
  response: ActionItemIntegrationsDisconnectUserMutation$data;
  variables: ActionItemIntegrationsDisconnectUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedUserIntegrationId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemIntegrationsDisconnectUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "DisconnectUserFromIntegrationPayload",
        "kind": "LinkedField",
        "name": "disconnectUserFromIntegration",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActionItemIntegrationsUserIntegration"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "disconnectUserFromIntegration(input:{})"
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ActionItemIntegrationsDisconnectUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "DisconnectUserFromIntegrationPayload",
        "kind": "LinkedField",
        "name": "disconnectUserFromIntegration",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserActionItemIntegrationNode",
                    "kind": "LinkedField",
                    "name": "userLevelActionItemIntegration",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "integrationProvider",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncedActionItemCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unsyncedActionItemCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastSyncDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "integrationSpecificDetails",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MicrosoftTodoUserNode",
                                "kind": "LinkedField",
                                "name": "microsoftTodoUser",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fullName",
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "externalListName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "externalListId",
                                "storageKey": null
                              }
                            ],
                            "type": "MicrosoftTodoUserIntegrationNode",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "disconnectUserFromIntegration(input:{})"
      }
    ]
  },
  "params": {
    "cacheID": "755948f058c5ae0df9624ecf4a18930a",
    "id": null,
    "metadata": {},
    "name": "ActionItemIntegrationsDisconnectUserMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemIntegrationsDisconnectUserMutation {\n  disconnectUserFromIntegration(input: {}) {\n    deletedUserIntegrationId\n    viewer {\n      integrations {\n        ...ActionItemIntegrationsUserIntegration\n      }\n      id\n    }\n  }\n}\n\nfragment ActionItemIntegrationsUserIntegration on UserIntegrations {\n  userLevelActionItemIntegration {\n    id\n    integrationProvider\n    syncEnabled\n    syncedActionItemCount\n    unsyncedActionItemCount\n    lastSyncDate\n    integrationSpecificDetails {\n      __typename\n      ...MicrosoftTodoIntegrationUserIntegrationDetails\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment MicrosoftTodoIntegrationUserIntegrationDetails on MicrosoftTodoUserIntegrationNode {\n  microsoftTodoUser {\n    user {\n      fullName\n      id\n    }\n    id\n  }\n  externalListName\n  externalListId\n}\n"
  }
};
})();

(node as any).hash = "30bddbc59e3a729e7ec6e40b0a830980";

export default node;
